   import { Action, SIGNED_OUT_USER } from '../../actions/index';
import { IApiProduct, IApplication, ICreateTPPResponse, IGetProductByIDResponse, IResource, ITPP } from '../../../API/ApiManagementTypes';
import { combineReducers, Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { GenericState, initialGenericState } from '../../reduxTypes';
import { FLUSH_RESULTS } from '../ApiManagementProductionReducer/ApiManagementProductionReducers';

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_USER_APPLICATIONS = 'GET_USER_APPLICATIONS';
export const DELETE_APPLICATION = 'DELETE_APPLICATION';



export interface IProductsState extends GenericState {
    data: IApiProduct[] | null
}

const initialProductsState: IProductsState = {
    loading: false,
    error: false,
    data: null
}

function getProductsReducer(state = initialProductsState, action: Action): IProductsState {
    switch (action.type) {
        case `${GET_PRODUCTS}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_PRODUCTS}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_PRODUCTS}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialProductsState
        default: return state;
    }
}

export const GET_PRODUCT = 'GET_PRODUCT';

export interface ProductByIDState extends GenericState {
    data: IGetProductByIDResponse | null
}

const initialProductByIDState: ProductByIDState = {
    loading: false,
    error: false,
    data: null
}

function getProductByIDReducer(state = initialProductByIDState, action: Action): ProductByIDState {
    switch (action.type) {
        case `${GET_PRODUCT}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_PRODUCT}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_PRODUCT}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialProductByIDState
        default: return state;
    }
}

export interface ApplicationsState extends GenericState<IApplication[]> { }

const initialApplicationsState: ApplicationsState = {
    loading: false,
    error: false,
    data: null
}

function getApplicationsReducer(state = initialApplicationsState, action: Action): ApplicationsState {
    switch (action.type) {
        case `${GET_USER_APPLICATIONS}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_USER_APPLICATIONS}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_USER_APPLICATIONS}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_RESULTS:
            return initialApplicationsState
        case SIGNED_OUT_USER:
            return initialApplicationsState
        default: return state;
    }
}

export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const CREATE_APPLICATION_ERROR = 'CREATE_APPLICATION_ERROR'
export const GET_APPLICATION = 'GET_APPLICATION';


export interface CreateApplicationResultState extends GenericState { }

const initialCreateApplicationResultState: CreateApplicationResultState = {
    loading: false,
    error: false,
    data: null
}

export const FLUSH_STATE = 'FLUSH_STATE';

function createApplicationResultReducer(state = initialCreateApplicationResultState, action: Action): CreateApplicationResultState {
    switch (action.type) {
        case `${CREATE_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${CREATE_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${CREATE_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case `${CREATE_APPLICATION_ERROR}`:
            return { ...state, error: true, data: action.payload }
        case FLUSH_STATE:
            return initialCreateApplicationResultState;
        case FLUSH_RESULTS:
            return initialCreateApplicationResultState;
        case SIGNED_OUT_USER:
            return initialCreateApplicationResultState
        default: return state;
    }
}

export interface IApplicationState extends GenericState {
    data: IApplication | null
}

const initialApplicationState: IApplicationState = {
    loading: false,
    error: false,
    data: null
}

function getApplicationReducer(state = initialApplicationState, action: Action): IApplicationState {
    switch (action.type) {
        case `${GET_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${GET_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialApplicationState
        default: return state;
    }
}

export const UPDATE_APPLICATION = 'UPDATE_APPLICATION'

function updateApplicationReducer(state = initialApplicationState, action: Action): IApplicationState {
    switch (action.type) {
        case `${UPDATE_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${UPDATE_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${UPDATE_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_RESULTS:
            return initialApplicationState;
        case SIGNED_OUT_USER:
            return initialApplicationState;
        default: return state;
    }
}

export interface DeleteApplicationState extends GenericState { }

const initialDeleteApplicationState: DeleteApplicationState = {
    loading: false,
    error: false,
    data: null
}

function deleteApplicationReducer(state = initialDeleteApplicationState, action: Action): DeleteApplicationState {
    switch (action.type) {
        case `${DELETE_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${DELETE_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload ?? 'deleted!' };
        case `${DELETE_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialDeleteApplicationState
        case 'DELETE_CLEANUP':
            return initialDeleteApplicationState
        default: return state;
    }
}

export interface IGenerateApiKeyState extends GenericState { }

const initialGenerateApiKeyState: IGenerateApiKeyState = initialGenericState;

export const GENERATE_API_KEY = 'GENERATE_API_KEY';
export const FLUSH_API_KEY = 'FLUSH_API_KEY';

function generateApiKeyReducer(state = initialGenerateApiKeyState, action: Action) {
    switch (action.type) {
        case `${GENERATE_API_KEY}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GENERATE_API_KEY}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GENERATE_API_KEY}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_API_KEY:
            return initialGenerateApiKeyState
        default: return state
    }
}

export interface IGenerateSecretState extends GenericState {
    data: IApplication
}

const initialGenerateSecretState: IGenerateSecretState = initialGenericState

export const GENERATE_SECRET = 'GENERATE_SECRET';
export const FLUSH_SECRET = 'FLUSH_SECRET';

function generateSecretReducer(state = initialGenerateSecretState, action: Action) {
    switch (action.type) {
        case `${GENERATE_SECRET}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GENERATE_SECRET}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GENERATE_SECRET}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_SECRET:
            return initialGenerateSecretState
        case FLUSH_RESULTS:
            return initialGenerateSecretState

        default: return state
    }

}

export const CREATE_TOKEN = 'CREATE_TOKEN'

export interface CreateTokenState extends GenericState { }

const initialCreateTokenState: CreateTokenState = {
    loading: false,
    error: false,
    data: null
}

function createTokenReducer(state = initialCreateTokenState, action: Action): CreateTokenState {
    switch (action.type) {
        case `${CREATE_TOKEN}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${CREATE_TOKEN}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${CREATE_TOKEN}_REJECTED`:
            return { ...state, loading: false, error: true, data: action.payload }
        case SIGNED_OUT_USER:
            return initialCreateTokenState;
        case 'FLUSH_TOKEN':
            return initialCreateTokenState;
        default: return { ...state }
    }
}


export const GET_TPPS = 'GET_TPPS'
export const EMAIL_VERIFIED = 'EMAIL_VERIFIED'
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED'
export interface ITPPState extends GenericState {
    data: ITPP[] | null,
    verified: boolean,
}

export interface ISelectedTPPState extends GenericState {
    data: ITPP | null,
    verified: boolean,
}

const initialTPPState: ITPPState = {
    loading: false,
    error: false,
    data: null,
    verified: true, //This is the most common case, despite everyone initally starting with this false
}

const initialSelectedTPPState: ISelectedTPPState = {
    loading: false,
    error: false,
    data: null,
    verified: true,
}

function getTPPReducer(state = initialTPPState, action: Action): ITPPState {
    switch (action.type) {
        case `${GET_TPPS}_PENDING`:
            return { ...state, loading: true, error: false, data: null }
        case `${GET_TPPS}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${GET_TPPS}_REJECTED`:
            return { ...state, loading: false, error: true }
        case EMAIL_NOT_VERIFIED:
            return { ...state, verified: false }
        case EMAIL_VERIFIED:
            return { ...state, verified: true }
        case SIGNED_OUT_USER:
            return initialTPPState
        default: return { ...state }
    }
}

export const GET_TPP_BY_ID = 'GET_TPP_BY_ID'

function getTPPByIdReducer(state = initialSelectedTPPState, action: Action): ISelectedTPPState {
    switch (action.type) {
        case `${GET_TPP_BY_ID}_PENDING`:
            return { ...state, data: null, loading: true, error: false, }
        case `${GET_TPP_BY_ID}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${GET_TPP_BY_ID}_REJECTED`:
            return { ...state, loading: false, error: true }
        case SIGNED_OUT_USER:
            return initialSelectedTPPState
        default: return { ...state }
    }
}

interface CreateTPPState extends GenericState {
    data: ICreateTPPResponse | null,
    noTPP: boolean,
    verified: boolean,
    email?: string,
    tpp?: ITPP
}

const initialCreateTPPState: CreateTPPState = {
    loading: false,
    error: false,
    data: null,
    noTPP: false,
    verified: true
}

export const CREATE_TPP = 'CREATE_TPP'
export const NO_TPP = 'NO_TPP'
export const TPP_ERROR = 'TPP_ERROR'
export const SET_EMAIL = 'SET_EMAIL';

function createTPPReducer(state: CreateTPPState = initialCreateTPPState, action: Action): CreateTPPState {
    switch (action.type) {
        case `${CREATE_TPP}_PENDING`:
            return { ...state, loading: true, error: false }
        case `${CREATE_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload, noTPP: false }
        case `${CREATE_TPP}_REJECTED`:
            return { ...state }
        case TPP_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case EMAIL_NOT_VERIFIED:
            return { ...state, verified: false }
        case EMAIL_VERIFIED:
            return { ...state, verified: true }
        case NO_TPP:
            return { ...state, noTPP: true }
        case SET_EMAIL:
            return { ...state, email: action.payload }
        case CLEAR_VALIDATION_TPP: 
            return initialCreateTPPState
        case SIGNED_OUT_USER:
            return initialCreateTPPState
        default: return { ...state }
    }
}

export const UPDATE_TPP = 'UPDATE_TPP';

function updateTPPReducer(state = initialCreateTPPState, action: Action): CreateTPPState {
    switch (action.type) {
        case `${UPDATE_TPP}_PENDING`:
            return { ...state, loading: true, error: false }
        case `${UPDATE_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload, noTPP: false }
        case `${UPDATE_TPP}_REJECTED`:
            return { ...state }
        case TPP_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case EMAIL_NOT_VERIFIED:
            return { ...state, verified: false }
        case EMAIL_VERIFIED:
            return { ...state, verified: true }
        case NO_TPP:
            return { ...state, noTPP: true }
        case SET_EMAIL:
            return { ...state, email: action.payload }
        case FLUSH_RESULTS:
            return initialCreateTPPState;
        case SIGNED_OUT_USER:
            return initialCreateTPPState;
        default: return { ...state }
    }
}

export const VALIDATE_TPP = 'VALIDATE_TPP';
export const TPP_VALIDATION_ERROR = 'TPP_VALIDATION_ERROR'
export const CLEAR_VALIDATION_TPP = 'CLEAR_VALIDATION_TPP'

interface ValidateTPPSTate extends GenericState { }

function validateTPPReducer(state: ValidateTPPSTate = initialCreateTPPState, action: Action): ValidateTPPSTate {
    switch (action.type) {
        case `${VALIDATE_TPP}_PENDING`:
            return { ...state, loading: false, error: false, }
        case `${VALIDATE_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${VALIDATE_TPP}_REJECTED`:
            return { ...state, loading: false, }
        case TPP_VALIDATION_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case CLEAR_VALIDATION_TPP:
            return initialCreateTPPState
        default: return { ...state }
    }
}

export const GET_TPP_RESOURCES = 'GET_TPP_RESOURCES';

interface ITPPResourceState extends GenericState<IResource[]> { }

const initialTPPResourcestate: ITPPResourceState = {
    loading: false,
    error: false,
    data: null,
}
function getTPPResourceReducer(state: ITPPResourceState = initialTPPResourcestate, action: Action): ITPPResourceState {
    switch (action.type) {
        case `${GET_TPP_RESOURCES}_PENDING`:
            return { ...state, loading: false, error: false, }
        case `${GET_TPP_RESOURCES}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${GET_TPP_RESOURCES}_REJECTED`:
            return { ...state, loading: false, }
        default: return state;
    }
}

interface IDeleteTPPState extends GenericState { }

const initialDeleteTPPState: IDeleteTPPState = {
    loading: false,
    error: false,
    data: null,
}

export const DELETE_TPP = 'DELETE_TPP'
function deleteTPPreducer(state: IDeleteTPPState = initialDeleteTPPState, action: Action): IDeleteTPPState {
    switch (action.type) {
        case `${DELETE_TPP}_PENDING`:
            return { ...state, loading: false, error: false, data: null }
        case `${DELETE_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: 'TPP_DELETED' }
        case `${DELETE_TPP}_REJECTED`:
            return { ...state, loading: false, data: null }
        case FLUSH_RESULTS:
            return initialDeleteTPPState
        default: return state;
    }
}

export interface ApiSandboxState {
    products: IProductsState,
    productDetails: ProductByIDState,
    userApplications: ApplicationsState,
    selectedApplication: IApplicationState,
    updateApplicationResult: IApplicationState,
    deleteApplicationStatus: DeleteApplicationState,
    createApplicationResult: CreateApplicationResultState,
    createTokenResult: CreateTokenState,
    userTPPs: ITPPState,
    selectedTPP: ISelectedTPPState,
    createTPPResult: CreateTPPState,
    updateTPPResult: CreateTPPState,
    validateTPPResult: ValidateTPPSTate,
    generateApiKeyState: IGenerateApiKeyState,
    generateSecretState: IGenerateSecretState,
    tppResourceState: ITPPResourceState,
    deleteTPPResult: IDeleteTPPState
}

const persistConfig = {
    key: 'tpp',
    storage: storageSession,
    whitelist: ['noTPP', 'verified']
}

const tppPersistConfig = {
    key: 'tppResult',
    storage: storageSession,
    whitelist: ['verified']
}
const persistTPPReducer = persistReducer(persistConfig, createTPPReducer)
const persistGetTPPReducer = persistReducer(tppPersistConfig, getTPPReducer)

export const ApiSandboxReducers: Reducer<ApiSandboxState> = combineReducers({
    products: getProductsReducer,
    productDetails: getProductByIDReducer,
    userApplications: getApplicationsReducer,
    selectedApplication: getApplicationReducer,
    updateApplicationResult: updateApplicationReducer,
    deleteApplicationStatus: deleteApplicationReducer,
    createApplicationResult: createApplicationResultReducer,
    createTokenResult: createTokenReducer,
    userTPPs: persistGetTPPReducer,
    selectedTPP: getTPPByIdReducer,
    createTPPResult: persistTPPReducer,
    updateTPPResult: updateTPPReducer,
    validateTPPResult: validateTPPReducer,
    generateApiKeyState: generateApiKeyReducer,
    generateSecretState: generateSecretReducer,
    tppResourceState: getTPPResourceReducer,
    deleteTPPResult: deleteTPPreducer
})

export const reducers = {
    getProductsReducer,
    getProductByIDReducer,
    getApplicationsReducer,
    getApplicationReducer,
    updateApplicationReducer,
    deleteApplicationReducer,
    createApplicationResultReducer,
    createTokenReducer,
    persistGetTPPReducer,
    getTPPByIdReducer,
    persistTPPReducer,
    updateTPPReducer,
    validateTPPReducer,
    generateApiKeyReducer,
    generateSecretReducer,
    getTPPResourceReducer,
    deleteTPPreducer
}


